<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <!-- <v-tooltip bottom> -->
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <span>{{ $t('close') }}</span>
          </v-tooltip> -->
          <v-toolbar-title>{{ json_data.save_type == "create" ? $t("menu.BranchCreate") : $t("menu.BranchEdit") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-3>
            <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                      <v-text-field
                        :label="$t('branch_code')"
                        v-model="form_model.code"
                        :rules="form_rules.code"
                        append-icon="fas fa-plus-circle"
                        required
                        hide-details
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type != 'create'">
                      <v-text-field :label="$t('branch_code')" v-model="form_model.code" :rules="form_rules.code" readonly required hide-details />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('branch_name')" placeholder="Ex: ตัวอย่างสาขา" hide-details v-model="form_model.name" required :rules="form_rules.name" />
                    </v-flex>
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea :label="$t('remark')" v-model="form_model.remark" hide-details />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 style="background-color:#fff; border-radius:5px;">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs12 style="margin-top:15px;">
                              <h3>{{ $t("Address") }}</h3>
                            </v-flex>
                            <v-flex xs12 md6 sm6 pa-1>
                              <v-text-field :label="$t('CompanyName')" v-model="form_model.companyname" hide-details />
                            </v-flex>
                            <v-flex x12 md6 sm6 pa-1>
                              <v-text-field label="เลขที่ผู้เสียภาษี" v-model="form_model.taxpayer_number" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Building')" v-model="form_model.building" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Room_No')" v-model="form_model.room_no" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Floor')" v-model="form_model.floor" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Village')" v-model="form_model.village" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('House_No')" v-model="form_model.house_no" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Village_No')" v-model="form_model.village_no" hide-details />
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Alley_Lane')" v-model="form_model.alley_lane" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Road')" v-model="form_model.road" hide-details />
                            </v-flex>

                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('SubDistrict_SubArea')" v-model="form_model.subdistrict_subarea" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('District_Area')" v-model="form_model.district_area" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Province')" v-model="form_model.province" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('Zipcode')" v-model="form_model.postcode" hide-details />
                            </v-flex>
                            <v-flex md6 sm6 x12 pa-1>
                              <v-text-field :label="$t('TelephoneNumber')" v-model="form_model.telephone1" hide-details />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";

export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      this.doNewGuid();
      if (val.data != null) {
        this.form_model = val.data;
      } else {
        this.$refs.form.resetValidation();
      }
    },
  },
  data: () => ({
    form_valid: false,

    form_model: {
      code: "",
      name: "",
      remark: "",
      editorCode: localStorage._usercode,
      address: "",
      companyname: "",
      building: "", //อาคาร
      room_no: "", //ห้อง
      floor: "", //ชั้น
      village: "", //หมู่บ้าน
      house_no: "", //บ้านเลขที่
      village_no: "", //หมู่ที่
      alley_lane: "", //ตรอก/ซอย
      road: "", //ถนน
      subdistrict_subarea: "", //ตำบล/แขวง
      district_area: "", //อำเภอ/เขต
      province: "", //จังหวัด
      postcode: "", //รหัสไปรษณีย์
      telephone1: "",
      telephone2: "",
      editor_code: "",
      taxpayer_number: "",
      company_id: localStorage._company_guid,
    },
    form_rules: {
      code: [(v) => !!v || "do not empty."],
      name: [(v) => !!v || "do not empty."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
  }),
  created: function() {
    this.doNewGuid();
  },
  methods: {
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    doNewGuid() {
      this.form_model.code = Utils.newGuid("B");
    },
    clearForm() {
      this.form_model = {
        code: "",
        name: "",
        remark: "",
        editorCode: localStorage._usercode,
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    onSave() {
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        SettingService.saveBranch(this.form_model)
          .then((res) => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdate() {
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        SettingService.updateBranch(this.form_model)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
  },
};
</script>
<style>
.v-card__text {
  padding: 0px !important ;
}
</style>
